export interface VideoTracker {
  onVideoPlayedToCompletion: (videoId: string) => void;
}

export class VideoEventManager {
  private tracker?: VideoTracker;

  setTracker(tracker: VideoTracker) {
    this.tracker = tracker;
  }

  attachVideoListeners(container: HTMLElement) {
    if (!this.tracker) {
      return;
    }

    const videoElements = container.querySelectorAll("video[data-video-id]");

    videoElements.forEach((videoElement) => {
      const video = videoElement as HTMLVideoElement;
      const videoId = video.getAttribute("data-video-id");

      if (!videoId) {
        return;
      }

      // Track when video plays to completion
      const handleVideoEnded = () => {
        this.tracker?.onVideoPlayedToCompletion(videoId);
      };

      // Also track when video is manually played close to the end
      const handleTimeUpdate = () => {
        const { currentTime, duration } = video;
        if (duration && currentTime >= duration * 0.95) {
          this.tracker?.onVideoPlayedToCompletion(videoId);
        }
      };

      video.addEventListener("ended", handleVideoEnded);
      video.addEventListener("timeupdate", handleTimeUpdate);

      // Store cleanup function for later use
      (video as any).__videoTrackingCleanup = () => {
        video.removeEventListener("ended", handleVideoEnded);
        video.removeEventListener("timeupdate", handleTimeUpdate);
      };
    });
  }

  detachVideoListeners(container: HTMLElement) {
    const videoElements = container.querySelectorAll("video[data-video-id]");

    videoElements.forEach((videoElement) => {
      const video = videoElement as HTMLVideoElement;
      const cleanup = (video as any).__videoTrackingCleanup;
      if (cleanup) {
        cleanup();
        delete (video as any).__videoTrackingCleanup;
      }
    });
  }
}

export const videoEventManager = new VideoEventManager();
